export const AUTH_SET_AUTH_TOKEN = 'AUTH_SET_AUTH_TOKEN';

const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
const SET_PARTNER = 'SET_PARTNER';

const getInitState = () => ({
    authToken: null,
    partner: {},
});

const actions = {
    [AUTH_SET_AUTH_TOKEN]: async ({commit}, {authToken, partner}) => {
        commit(SET_AUTH_TOKEN, authToken);
        commit(SET_PARTNER, partner);
    },
};

const mutations = {
    [SET_AUTH_TOKEN]: (state, authToken) => {
        state.authToken = authToken;
    },
    [SET_PARTNER]: (state, partner) => {
        state.partner = partner;
    },
};

export default {
    state: getInitState(),
    getters: {},
    actions,
    mutations,
};